import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createQueryClient } from '@/api/queryClient';
import { ConfirmHost, Toaster } from '@/components';
import { ReloginModal } from '@/layout/ReloginModal';
import { installUnauthorizedHandler } from '@/stores/reauth';
import { applyTheme, useThemeStore } from '@/stores/theme';
import App from './App';
import './styles/theme.css';
import './styles/base.css';

const queryClient = createQueryClient();

// A 401 anywhere means the session ended: forget cached data; RequireAuth then redirects
// to /login?next=<current page>. With unsaved work (annotator edits) the page stays and a
// re-login dialog opens instead (stores/reauth.ts).
installUnauthorizedHandler(queryClient);

applyTheme(useThemeStore.getState().preference);

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster />
      <ConfirmHost />
      <ReloginModal />
    </QueryClientProvider>
  </StrictMode>,
);
